@if (publicInfoVisible) {
  <aside class="public-info-panel" id="informacion" aria-label="Información pública">
    <header>
      <h2>Información</h2>
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="12" cy="12" r="9" />
        <path d="M12 11v6" />
        <path d="M12 7h.01" />
      </svg>
      <button type="button" (click)="publicInformationToggled.emit()" aria-label="Cerrar información pública">
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M18 6 6 18" />
          <path d="m6 6 12 12" />
        </svg>
      </button>
    </header>
    <p>Visor público de la Real Acequia de Moncada</p>

    <ul class="public-capabilities">
      <li>
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M12 3c2.8 3.3 4.2 6 4.2 8.2a4.2 4.2 0 1 1-8.4 0C7.8 9 9.2 6.3 12 3Z" />
          <path d="M12 14.8v-4" />
        </svg>
        <span><strong>Mapa básico RAM</strong><small>Ortofoto + acequias + zonas/espacios regados</small></span>
      </li>
      <li>
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="m12 3 8 4-8 4-8-4 8-4Z" />
          <path d="m4 12 8 4 8-4" />
          <path d="m4 17 8 4 8-4" />
        </svg>
        <span><strong>Información no sensible</strong><small>Solo datos generales no sensibles</small></span>
      </li>
      <li>
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6S2 12 2 12Z" />
          <circle cx="12" cy="12" r="3" />
        </svg>
        <span><strong>Consulta limitada</strong><small>Fichas con campos no sensibles</small></span>
      </li>
      <li>
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <rect x="5" y="10" width="14" height="10" rx="2" />
          <path d="M8 10V7a4 4 0 0 1 8 0v3" />
        </svg>
        <span><strong>Sin edición</strong><small>Solo visualización</small></span>
      </li>
    </ul>

    <p class="public-note">
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="12" cy="12" r="9" />
        <path d="M12 11v6" />
        <path d="M12 7h.01" />
      </svg>
      Este visor es de acceso público y no requiere registro.
    </p>
  </aside>
}

<div class="public-data-banner" [class.behind-panel]="publicInfoVisible || aboutRamVisible" role="status">
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M12 22s7-3.2 7-10V5l-7-3-7 3v7c0 6.8 7 10 7 10Z" />
    <path d="m9 12 2 2 4-5" />
  </svg>
  <strong>Datos públicos y no sensibles</strong>
  <span>Información general disponible para toda la ciudadanía.</span>
</div>

@if (aboutRamVisible) {
  <aside class="about-ram-panel" aria-labelledby="about-ram-title">
    <header>
      <h2 id="about-ram-title">Acerca de la RAM</h2>
      <button type="button" (click)="aboutRamClosed.emit()" aria-label="Cerrar acerca de la RAM">
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M18 6 6 18" />
          <path d="m6 6 12 12" />
        </svg>
      </button>
    </header>
    <div class="about-ram-content">
      <p>
        La Real Acequia de Moncada es una de las grandes instituciones históricas de riego de la huerta valenciana. Su red de acequias ha articulado durante siglos el reparto del agua y el paisaje agrario de los municipios situados al norte de Valencia.
      </p>
      <p>
        Su origen se vincula a la tradición hidráulica medieval y a la organización comunitaria del riego. A través de tomas, brazales y turnos, la acequia ha permitido ordenar el uso del agua, mantener cultivos y sostener una forma de gestión colectiva ligada al territorio.
      </p>
      <p>
        Para saber más puedes visitar la <a href="https://realacequiamoncada.com" target="_blank">web de la Real Acequia de Moncada</a>.
      </p>
    </div>
  </aside>
}
